import angular from "angular"
import cgNotify from "@cgross/angular-notify";
import core from "../../../core/core.module";

let mod = angular
    .module('refundOrder', [
        cgNotify,
        core
    ])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('refund-modal-popup.html', require('./refund-modal-popup.html'));
    }])
    .component('refundOrder', {
        template: require('./refundOrder.html'),
        controller: ['$q', '$http', 'notify', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($q, $http, notify, $scope) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.order = $ctrl.resolve.order;

        $ctrl.ticket = $ctrl.resolve.ticket;

        $ctrl.tickets = [];

        if ($ctrl.ticket) {
            $ctrl.tickets.push($ctrl.ticket);
        } else {
            $ctrl.order.tickets.forEach(function (ticket) {
                $ctrl.tickets.push(ticket);
            });
        }

        $ctrl.step = 1;
    };

    $scope.$on('modal.closing', function(event, reason, closed) {
        if (closed) {
            return;
        }
        event.preventDefault();
        $ctrl.close({
            $value: {
                isSend: $ctrl.step == 3
            }
        });
    });

    $ctrl.loadStatusAndInfo = function () {
        $ctrl.statusLoading = true;
        getOrderStatus().then(
            function () {
                if ($ctrl.ticket) {
                    getTicketReturnInfo().then(
                        function () {
                            $ctrl.statusLoading = false;
                            $ctrl.step = 2;
                        },
                        function () {
                            $ctrl.statusLoading = false;
                        }
                    )
                } else {
                    getOrderReturnInfo().then(
                        function () {
                            $ctrl.statusLoading = false;
                            $ctrl.step = 2;
                        },
                        function () {
                            $ctrl.statusLoading = false;
                        }
                    )
                }
            },
            function () {
                $ctrl.statusLoading = false;
            }
        );
    };

    function getOrderStatus() {
        let defer = $q.defer();
        $http
            .get('/railways-api/get-order-status', {
                params: {
                    orderId: $ctrl.order.id
                }
            })
            .then(
                function (response) {
                    $ctrl.order.actualStatus = response.data.orderStatus;
                    let ticketsStatuses = response.data.ticketsStatuses;
                    for (let i = 0; i < ticketsStatuses.length; i++) {
                        for (let j = 0; j < $ctrl.tickets.length; j++) {
                            if (ticketsStatuses[i].expressId == $ctrl.tickets[j].express_id) {
                                $ctrl.tickets[j].actualStatus = ticketsStatuses[i].status;
                                break;
                            }
                        }
                    }
                    if ($ctrl.order.actualStatus == 10) {
                        nf('Заявка в обработке. Повторите запрос через 10 секунд');
                        defer.reject();
                        return;
                    }
                    if ($ctrl.order.actualStatus == 11) {
                        nf('Заявка временно заблокирована. Повторите запрос через 10 секунд');
                        defer.reject();
                        return;
                    }
                    defer.resolve();
                },
                function (error) {
                    if (error.data.messages) {
                        nf(error.data.messages[0]);
                    } else {
                        nf('Произошла неизвестная ошибка. Обратитесть к администратору');
                    }
                    defer.reject();
                }
            );
        return defer.promise;
    }

    function getOrderReturnInfo() {
        let defer = $q.defer();
        $http
            .get('/railways-api/get-order-return-info', {
                params: {
                    orderId: $ctrl.order.id
                }
            })
            .then(
                function (response) {
                    let tickets = response.data.tickets;
                    for (let i = 0; i < tickets.length; i++) {
                        for (let j = 0; j < $ctrl.tickets.length; j++) {
                            if ($ctrl.tickets[j].express_id == tickets[i].expressId) {
                                $ctrl.tickets[j].returnSum = tickets[i].returnSum;
                                break;
                            }
                        }
                    }
                    defer.resolve();
                },
                function (error) {
                    if (error.data.messages) {
                        nf(error.data.messages[0]);
                    } else {
                        nf('Произошла неизвестная ошибка. Обратитесть к администратору');
                    }
                    defer.reject();
                }
            );
        return defer.promise;
    }

    function getTicketReturnInfo() {
        let defer = $q.defer();
        $http
            .get('/railways-api/get-ticket-return-info', {
                params: {
                    orderId: $ctrl.order.id,
                    ticketNumber: $ctrl.ticket.number
                }
            })
            .then(
                function (response) {
                    let tickets = response.data.tickets;
                    for (let i = 0; i < tickets.length; i++) {
                        for (let j = 0; j < $ctrl.tickets.length; j++) {
                            if ($ctrl.tickets[j].express_id == tickets[i].expressId) {
                                $ctrl.tickets[j].returnSum = tickets[i].returnSum;
                                break;
                            }
                        }
                    }
                    defer.resolve();
                },
                function (error) {
                    if (error.data.messages) {
                        nf(error.data.messages[0]);
                    } else {
                        nf('Произошла неизвестная ошибка. Обратитесть к администратору');
                    }
                    defer.reject();
                }
            );
        return defer.promise;
    }

    $ctrl.sendToReturn = function () {

        $ctrl.sendLoading = true;

        let defer = $ctrl.ticket ? sendTicketToReturn() : sendOrderToReturn();

        defer.then(
            function () {
                $ctrl.sendLoading = false;
                $ctrl.step = 3;
            },
            function () {
                $ctrl.sendLoading = false;
            }
        );
    };

    function sendOrderToReturn() {
        let defer = $q.defer();
        $http
            .post('/railways-api/request-order-return', {
                orderId: $ctrl.order.id,
            })
            .then(
                function () {
                    defer.resolve();
                },
                function (error) {
                    if (error.data.messages) {
                        nf(error.data.messages[0]);
                    } else {
                        nf('Произошла неизвестная ошибка. Обратитесть к администратору');
                    }
                    defer.reject();
                }
            );

        return defer.promise;
    }

    function sendTicketToReturn() {
        let defer = $q.defer();
        $http
            .post('/railways-api/request-ticket-return', {
                orderId: $ctrl.order.id,
                ticketNumber: $ctrl.ticket.number
            })
            .then(
                function () {
                    defer.resolve();
                },
                function (error) {
                    if (error.data.messages) {
                        nf(error.data.messages[0]);
                    } else {
                        nf('Произошла неизвестная ошибка. Обратитесть к администратору');
                    }
                    defer.reject();
                }
            );
        return defer.promise;
    }

    function nf(message) {
        notify({
            message: message,
            classes: 'alert alert-danger',
            duration: 3000
        });
    }

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/orders/components/refundOrder/refundOrder.js